module.exports = __webpack_public_path__ + "img/Accessoires_gateaux.d8662f0.jpg";